import Pagination from "../../components/Pagination";
import FormInput from '../../components/FormInput';
import ImageModal from "./ImageModal.vue";
export default {
    name: "bus_type_index_component",
    components: {Pagination, FormInput, ImageModal},
    data() {
        return {
            bus_types: [],
            links: {},
            page: 1,
            isLoading: true,
            searchBus: '',
            searchStorey: null,
            showModal: false,
            selectedBus: {}
        }
    },

    mounted() {

    },

    created() {
        this.page = this.$route.params.page;
        this.getBusTypes();
    },

    methods: {
        update() {
            console.log('something');
        },
        deleteItem(item) {
            let indx = this.bus_types.indexOf(item);
            if (indx >= 0 && confirm(this.i18n('Do you really want to delete?'))) {
                this.$api.delete('bus-model.delete', item.id).then(res => {
                    if (!res.errors) {
                        this.bus_types.splice(indx, 1);
                    }
                })
            }
        },
        getBusTypes() {
            this.isLoading = true;
            this.$api.get('bus-model.index', {page: this.page, type: this.searchBus, storey: this.searchStorey})
                .then(response => {
                    this.bus_types = response.data;
                    this.links = response.links;

                    console.log(this.links)
                }).finally(() => {
                this.isLoading = false;
            });
        },
		filterBuses() {
            this.page = 1;
            this.getBusTypes()
        },
        uploadBusLogo(bus) {
            this.selectedBus = bus
            this.$refs.imageModal.open()
        },
        uploadImage(file) {
            let formData = new FormData();
            formData.append('image', file);
            this.$api.post('bus-model.upload', formData, this.selectedBus.id, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(res => {
                this.selectedBus.bus_logo = res.path;
            })
            .catch(err => {
                console.log(err);
            });
        }

    },
    beforeRouteUpdate(to, from, next) {
        console.log("before route")
        let page = to.params.page;
        if (page) {
            this.page = page;
            this.getBusTypes();
        }
        next();
    },

}
